import { createFileRoute, Link } from '@tanstack/react-router';
import { DashboardFilterProvider } from '@/lib/common/hooks/useDashboardFilter';
import { useDemoProvider } from '@/lib/demo/hooks/useDemo';
import { Button, Card, CardBody } from '@heroui/react';
import PlayerDashboard from '@/components/dashboard/PlayerDashboard';

export const Route = createFileRoute('/demo')({
    component: RouteComponent,
});

function RouteComponent() {
    const { user } = useDemoProvider();

    return (
        <div className='px-2'>
            <div className='gap-2 justify-self-center px-12 py-10 text-center'>
                <h1 className='bg-linear-to-r mb-6 from-green-500 to-teal-500 bg-clip-text pb-2 text-5xl font-bold tracking-tight text-transparent'>
                    Caddy Stats - Advanced Golf Analytics
                </h1>
                <div className='mt-3 text-2xl font-semibold text-gray-700'>Demo Version</div>
                <Button variant='bordered' size='lg' className='font-semibold' as={Link} to='/pricing'>
                    See Pricing
                </Button>
            </div>
            <DashboardFilterProvider>
                <Card className='mx-2 mt-2 md:mx-auto md:max-w-7xl'>
                    <CardBody>
                        <PlayerDashboard player={user} />
                    </CardBody>
                </Card>
            </DashboardFilterProvider>
        </div>
    );
}
